"use client";

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@focal/ui-kit";
import { Icon } from "@focal/ui-kit";
import { Button } from "@focal/ui-kit";

interface VersionMismatchModalProps {
  open: boolean;
  onReload: () => void;
  onDismiss: () => void;
}

export const VersionMismatchModal = ({
  open,
  onReload,
  onDismiss,
}: VersionMismatchModalProps) => {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent className="max-w-md">
        <Button
          variant="ghost"
          size="icon"
          className="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground"
          onClick={onDismiss}
        >
          <Icon name="CloseIcon" size="sm" />
          <span className="sr-only">Close</span>
        </Button>
        <AlertDialogHeader>
          <AlertDialogTitle>Update Available</AlertDialogTitle>
          <AlertDialogDescription className="space-y-2">
            <p>
              A new version of the application is available. Please refresh to
              continue using the latest features and improvements.
            </p>
            <p className="text-sm text-muted-foreground">
              Note: Continuing without refreshing may cause compatibility
              issues.
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button onClick={onReload}>Refresh now</Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
